export const GET_CONTACT_LIST_START = 'GET_CONTACT_LIST_START';
export const GET_CONTACT_LIST_SUCCESS = 'GET_CONTACT_LIST_SUCCESS';
export const GET_CONTACT_LIST_ERROR = 'GET_CONTACT_LIST_ERROR';
export const ADD_NEW_CONTACT_ERROR = 'ADD_NEW_CONTACT_ERROR';
export const ADD_NEW_CONTACT_SUCCESS = 'ADD_NEW_CONTACT_SUCCESS';
export const ADD_NEW_CONTACT_START = 'ADD_NEW_CONTACT_START';
export const ADD_EXTERNAL_CONTACT_ERROR =
  'ADD_EXTERNAL_CONTACT_ERROR';
export const ADD_EXTERNAL_CONTACT_SUCCESS =
  'ADD_EXTERNAL_CONTACT_SUCCESS';
export const ADD_EXTERNAL_CONTACT_START =
  'ADD_EXTERNAL_CONTACT_START';
export const GET_EXTERNAL_CONTACT_LIST_START =
  'GET_EXTERNAL_CONTACT_LIST_START';
export const GET_EXTERNAL_CONTACT_LIST_SUCCESS =
  'GET_EXTERNAL_CONTACT_LIST_SUCCESS';
export const GET_EXTERNAL_CONTACT_LIST_ERROR =
  'GET_EXTERNAL_CONTACT_LIST_ERROR';
export const DELETE_CONTACT_START = 'DELETE_CONTACT_START';
export const DELETE_CONTACT_ERROR = 'DELETE_CONTACT_ERROR';
export const DELETE_CONTACT_SUCCESS = 'DELETE_CONTACT_SUCCESS';
export const CLEAR_DELETE_CONTACT = 'CLEAR_DELETE_CONTACT';

// current contact, in contact detail

export const SET_CURRENT_CONTACT = 'SET_CURRENT_CONTACT';

export const UPDATE_CONTACT_PICTURE_START =
  'UPDATE_CONTACT_PICTURE_START';
export const UPDATE_CONTACT_PICTURE_ERROR =
  'UPDATE_CONTACT_PICTURE_ERROR';
export const UPDATE_CONTACT_PICTURE_SUCCESS =
  'UPDATE_CONTACT_PICTURE_SUCCESS';
export const CLEAR_UPDATE_CONTACT_PICTURE =
  'CLEAR_UPDATE_CONTACT_PICTURE';

export const ADD_REMOVE_FAVOURITE_ERROR =
  'ADD_REMOVE_FAVOURITE_ERROR';
export const ADD_REMOVE_FAVOURITE_START =
  'ADD_REMOVE_FAVOURITE_START';
export const ADD_REMOVE_FAVOURITE_SUCCESS =
  'ADD_REMOVE_FAVOURITE_SUCCESS';
export const CLEAR_ADD_REMOVE_FAVORITE = 'CLEAR_ADD_REMOVE_FAVORITE';
export const GET_FAVORITES_LIST_START = 'GET_FAVORITES_LIST_START';
export const GET_FAVORITES_LIST_SUCCESS =
  'GET_FAVORITES_LIST_SUCCESS';
export const GET_FAVORITES_LIST_ERROR = 'GET_FAVORITES_LIST_ERROR';

// block unblock contact
export const BLOCK_UNBLOCK_ERROR = 'BLOCK_UNBLOCK_ERROR';
export const BLOCK_UNBLOCK_START = 'BLOCK_UNBLOCK_START';
export const BLOCK_UNBLOCK_SUCCESS = 'BLOCK_UNBLOCK_SUCCESS';
export const CLEAR_BLOCK_UNBLOCK = 'CLEAR_BLOCK_UNBLOCK';
export const GET_BLOCKED_LIST_START = 'GET_BLOCKED_LIST_START';
export const GET_BLOCKED_LIST_SUCCESS = 'GET_BLOCKED_LIST_SUCCESS';
export const GET_BLOCKED_LIST_ERROR = 'GET_BLOCKED_LIST_ERROR';
export const GET_BLOCKING_LIST_START = 'GET_BLOCKING_LIST_START';
export const GET_BLOCKING_LIST_SUCCESS = 'GET_BLOCKING_LIST_SUCCESS';
export const GET_BLOCKING_LIST_ERROR = 'GET_BLOCKING_LIST_ERROR';
export const UPDATE_BLOCKING_LIST = 'UPDATE_BLOCKING_LIST';
